import React, { Fragment, Component } from 'react';
import { Button } from 'reactstrap';

import Gallery from '../ui/Gallery';
import Overlay from '../ui/Overlay';
import importAll from '../util/importAll';

import Icon from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faTimes
} from '@fortawesome/fontawesome-free-solid';

class GallaryCategory extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state.photos = importAll(props.context);

    const hash = window.location.hash;
    if (hash && hash !== '#') {
      const name = './' + hash.substr(1);
      const link = this.state.photos[name];
      if (name && link) this.state.selected = { name, link };
    }
  }

  render() {
    const { selected, photos } = this.state;
    const names = Object.keys(photos);

    if (!selected) {
      window.history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search
      );
    }

    return (
      <Fragment>
        <Overlay
          hidden={!selected}
          onClick={() => this.setState({ selected: undefined })}
        >
          <div className="overlay-bar">
            <button
              className="overlay-button-close"
              onClick={e => {
                e.stopPropagation();
                this.setState({ selected: undefined });
              }}
            >
              <Icon icon={faTimes} size="lg" />
            </button>
          </div>
          <div className="overlay-image-container">
            <Button
              outline
              color="light"
              className="overlay-button prev"
              onClick={e => {
                e.stopPropagation();
                this.handlePrev();
              }}
            >
              <Icon icon={faAngleLeft} size="lg" />
            </Button>
            <img
              src={selected && selected.link}
              className="enlarged"
              alt=""
              onClick={e => {
                e.stopPropagation();
              }}
            />
            <Button
              outline
              color="light"
              className="overlay-button next"
              onClick={e => {
                e.stopPropagation();
                this.handleNext();
              }}
            >
              <Icon icon={faAngleRight} size="lg" />
            </Button>
          </div>
          <div className="overlay-bar">
            <div className="overlay-text center">
              {selected && names.indexOf(selected.name) + 1} of {names.length}
            </div>
          </div>
        </Overlay>
        <Gallery photos={photos} onSelect={this.handleSelect} />
      </Fragment>
    );
  }

  handleSelect = (name, link) => {
    window.location.hash = name.substr(2);
    this.setState({ selected: { name, link } });
  };

  handlePrev = () => {
    const { selected, photos } = this.state;
    const names = Object.keys(photos);
    const index = names.indexOf(selected.name);

    if (index === -1) return this.setState({ selected: undefined });
    let newIndex = index > 0 ? index - 1 : names.length - 1;

    const name = names[newIndex];
    this.handleSelect(name, photos[name]);
  };

  handleNext = () => {
    const { selected, photos } = this.state;
    const names = Object.keys(photos);
    const index = names.indexOf(selected.name);

    if (index === -1) return this.setState({ selected: undefined });
    let newIndex = index < names.length - 1 ? index + 1 : 0;

    const name = names[newIndex];
    this.handleSelect(name, photos[name]);
  };
}

export default GallaryCategory;
